/** Six squares, one per area in a fixed order: solid is read and write, tinted is read, hairline is not shared. */
import { Tip } from "../kit/overlays";
import { AREAS, type Scopes } from "../../shared/access";

const WORD = { rw: "read and write", r: "read only", none: "not shared" } as const;

export function ScopeStrip({ scopes, size = 10 }: { scopes: Scopes; size?: number }) {
  return (
    <Tip text={AREAS.map((a) => `${a.label}: ${WORD[scopes[a.key]]}`).join(" · ")}>
      <span className="scope" tabIndex={0} role="img" aria-label={AREAS.map((a) => `${a.label} ${WORD[scopes[a.key]]}`).join(", ")}>
        {AREAS.map((a) => <i key={a.key} className={scopes[a.key]} style={{ width: size, height: size }} />)}
      </span>
    </Tip>
  );
}
